module.exports = __webpack_public_path__ + "24dd6a222cafbf45b93288ce3844052f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-blue.png
// module id = 1334
// module chunks = 0